import { AxiosInstance, AxiosResponse } from 'axios';
import {
  AdherentParticulierResponse,
  AdherentParticulierApiFactory,
  DemandeContact,
  ClientApiFactory,
} from './swagger';

export interface IApi {
  getAdherentParticulierAdhesions(adherentParticulierId: string): Promise<AdherentParticulierResponse>;
  postContact(params: DemandeContact): Promise<number>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const adherentApi = AdherentParticulierApiFactory({}, endpoint, axiosClient);

  const clientApi = ClientApiFactory({}, endpoint, axiosClient);

  const getAdherentParticulierAdhesions = (adherentParticulierId): Promise<AdherentParticulierResponse> =>
    new Promise((resolve, reject) => {
      adherentApi
        .getAdherentById(adherentParticulierId)
        .then((response: AxiosResponse<AdherentParticulierResponse>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const postContact = (params): Promise<number> =>
    new Promise((resolve, reject) => {
      clientApi
        .demanderContact(params)
        .then((response: AxiosResponse<void>) => {
          resolve(response.status);
        })
        .catch((error: any) => reject(error));
    });

  return {
    getAdherentParticulierAdhesions,
    postContact,
  };
};

export default create;
